import { render } from "./Satuan.vue?vue&type=template&id=d7ff690c"
import script from "./Satuan.vue?vue&type=script&lang=js"
export * from "./Satuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__